import axios from "axios";
import {TTP_API_URL} from "Config";
import { updateSourceToken, throwCatchedError } from 'utils';

export const getPayinUrl = (token, orderId, amount) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/get-payin-url`;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('orderId',orderId);
  formData.append('amount',amount);
  formData.append('currency',"EUR");
  formData.append('fees',"0");
  formData.append('mp_card_type',"CB_VISA_MASTERCARD,BCMC");
  return axios.post(requestUrl, formData);
};

export const getUserCardList = (token, userId, subscriptionId, isSubscription) => {


  const requestUrl = `${TTP_API_URL}/billing/mango-pay/get-user-cards`;

  let params = {
    access_token: token,
    userId,
  };
  if(subscriptionId != null)
    params.subscriptionId = subscriptionId;
  if(isSubscription != null)
    params.isSubscription = isSubscription;

  return axios.get(requestUrl, {
    params: params
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const cardWebPayin = (token, orderId, amount, cardId, deleteCard, params) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/pay-with-registred-card`;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('orderId',orderId);
  formData.append('amount',amount);
  formData.append('currency',"EUR");
  formData.append('fees',"0");
  formData.append('cardId',cardId);
  formData.append('deleteCard',deleteCard ? 1 : 0);
  formData.append('params', JSON.stringify(params));
  return axios.post(requestUrl, formData);
};

export const mangoPayCallback = (token, orderId, transactionId, deleteCard) => {

  const requestUrl = `${TTP_API_URL}/billing/mango-pay/mango-pay-callback-ajax`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      orderId,
      transactionId,
     deleteCard ,
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const createCardRegistration = (token, orderId,cardType, userId) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/create-card-registration`;
  var formData = new FormData();
  formData.append('access_token', token);
  if(orderId != null)
    formData.append('orderId',orderId);
  formData.append('currency',"EUR");
  formData.append('cardType',cardType);
  if(userId != null)
    formData.append('userId',userId);
  return axios.post(requestUrl, formData);
};

export const getToken = (urlHetToken, data, accessKeyRef, returnURL, cardNumber, cardExpirationDate, cardCvx) => {
  const requestUrl =urlHetToken;
  var formData = new FormData();
  formData.append('data',data);
  formData.append('accessKeyRef',accessKeyRef);
  formData.append('returnURL',returnURL);
  formData.append('cardNumber',cardNumber);
  formData.append('cardExpirationDate',cardExpirationDate);
  formData.append('cardCvx',cardCvx);
  return axios.post(requestUrl, formData);
};

export const deactivateCard = (token, cardId) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/deactivate-card`;
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('cardId',cardId);
  return axios.post(requestUrl, formData);
};

export const refundWithMangoPay = (token, orderId, isCreditNote, creditNoteId) => {
  const requestUrl =TTP_API_URL+`/billing/assignment/refund-mango-pay`;
  let formData = new FormData();
  formData.append('orderId', orderId);
  formData.append('isCreditNote', isCreditNote);
  if(creditNoteId != null) {
    formData.append('creditNoteId', creditNoteId);
  }

  formData.append('access_token', token);
  return axios.post(requestUrl, formData);
};

export const FeedMangoWalletForOrganizationPayIn = (token, orderId, amount, cardId, deleteCard, params, isCreditNote, creditNoteId, isRefund, redirectionURL, organizationId, userId) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/configure-vendor-wallet`;
  let formData = new FormData();

  formData.append('access_token', token);
  formData.append('orderId',orderId);
  formData.append('amount',amount * 100);
  formData.append('currency',"EUR");
  formData.append('fees',"0");
  formData.append('cardId',cardId);
  formData.append('deleteCard',deleteCard ? 1 : 0);
  formData.append('params', JSON.stringify(params));

  formData.append('isCreditNote', isCreditNote);
  formData.append('creditNoteId', creditNoteId);
  formData.append('isRefund', isRefund);
  formData.append('redirectionURL', redirectionURL);
  formData.append('clientId', organizationId);
  formData.append('userId', userId);

  return axios.post(requestUrl, formData);
};

export const getOrganizationCardList = (token, organizationId) => {

  const requestUrl = `${TTP_API_URL}/billing/mango-pay/get-vendor-cards-list`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      clientId: organizationId,
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const cardRegistrationForOrganization = (token, clientId,cardType) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/create-card-registration-for-client`;

  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('clientId',clientId);
  formData.append('currency',"EUR");
  formData.append('cardType',cardType);

  return axios.post(requestUrl, formData);
};

export const mangoPayCallbackForOrganization = (token, orderId, transactionId, deleteCard, creditNoteId , isCreditNote, amount, isRefund, redirectionURL, userId) => {

  const requestUrl = `${TTP_API_URL}/billing/mango-pay/configure-wallet-callback-ajax`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      creditNoteId: creditNoteId,
      isCreditNote: isCreditNote,
      amount: amount,
      isRefund: isRefund,
      redirectionURL: redirectionURL,
      userId: userId,
      orderId,
      transactionId,
      deleteCard ,
    }
  }).catch(function(thrown) {
    throwCatchedError(thrown)
  });
};

export const getOrganizationMangoBalance = (token, organizationId) => {
  let requestUrl = `${TTP_API_URL}/billing/mango-pay/get-organization-mango-balance`;
  let params = {
    access_token: token,
    clientId: organizationId,
  }

  return axios.get(requestUrl, {
    params
  });
};

export const organizationPayout = (token, issuerId,amount) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/organization-payout`;

  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('issuerId',issuerId);
  formData.append('currency',"EUR");
  formData.append('amount',amount);
  formData.append('fees',0);

  return axios.post(requestUrl, formData);
};

export const createSubscription = (token, orderId, cardId, params) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/create-recurring-payment`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('orderId',orderId);
  formData.append('cardId',cardId);
  formData.append('params', JSON.stringify(params));

  return axios.post(requestUrl, formData);
};


export const createMidCit = (token, orderId, subscriptionId, params) => {
  const requestUrl =TTP_API_URL+`/billing/subscription/create-recurring-payin-mid-cit`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('orderId',orderId);
  formData.append('subscriptionId', subscriptionId);
  formData.append('params', JSON.stringify(params));

  return axios.post(requestUrl, formData);
};

export const updateSubscriptionCard = (token, subscriptionId, cardId, params) => {
  const requestUrl =TTP_API_URL+`/billing/subscription/update-recurring-payment-card`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('cardId',cardId);
  formData.append('subscriptionId', subscriptionId);
  formData.append('params', JSON.stringify(params));

  return axios.post(requestUrl, formData);
};


export const createBankwire = (token, amount, tag, issuerId) => {
  const requestUrl =TTP_API_URL+`/billing/mango-pay/bank-wire-payin`;
  var formData = new FormData();

  formData.append('access_token', token);
  formData.append('amount',amount);
  formData.append('tag', tag);
  formData.append('issuerId', issuerId);

  return axios.post(requestUrl, formData);
};


export const getBankwires = (token, organizationId) => {
  let requestUrl = `${TTP_API_URL}/billing/mango-pay/get-bank-wire-payins`;

  let params = {
    access_token: token,
    issuerId: organizationId,
  }

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./app/api/TamtamAPI/mangoPay.js